import axios from "axios";

const API_BASE_URL = "/api/roles";

/**
 * Role API Service
 * Handles all HTTP requests related to role operations
 */
class RoleService {
  /**
   * Create a new role
   */
  async createRole(roleData) {
    try {
      const response = await axios.post(API_BASE_URL, roleData, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Get all roles with pagination and filters
   */
  async getAllRoles(params = {}) {
    try {
      const queryParams = new URLSearchParams();

      if (params.page) queryParams.append("page", params.page);
      if (params.limit) queryParams.append("limit", params.limit);
      if (params.search) queryParams.append("search", params.search);
      if (params.isActive !== undefined)
        queryParams.append("isActive", params.isActive);
      if (params.sort) queryParams.append("sort", params.sort);

      const response = await axios.get(
        `${API_BASE_URL}?${queryParams.toString()}`
      );
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Get single role by ID
   */
  async getRoleById(roleId) {
    try {
      const response = await axios.get(`${API_BASE_URL}/${roleId}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Update role
   */
  async updateRole(roleId, roleData) {
    try {
      const response = await axios.put(`${API_BASE_URL}/${roleId}`, roleData, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Delete role
   */
  async deleteRole(roleId) {
    try {
      const response = await axios.delete(`${API_BASE_URL}/${roleId}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Get all active roles (for dropdowns)
   */
  async getActiveRoles() {
    try {
      const response = await axios.get(`${API_BASE_URL}/active/list`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Handle API errors
   */
  handleError(error) {
    if (error.response) {
      return {
        message: error.response.data?.message || "An error occurred",
        status: error.response.status,
        data: error.response.data,
      };
    } else if (error.request) {
      return {
        message: "Network error. Please check your connection.",
        status: 0,
      };
    } else {
      return {
        message: error.message || "An unexpected error occurred",
        status: 0,
      };
    }
  }
}

const roleService = new RoleService();
export default roleService;

